<template>
    <el-form label-position="right" :model="tenant" ref="tenantForm" :rules="tenantFormRule" label-width="100px">
        <el-form-item :label="$t('tenant.productKey')" prop="productKey">
            <label>{{productKey}}</label>
        </el-form-item>
        <el-form-item :label="$t('tenant.tenantName')" prop="tenantName">
            <el-input v-model="tenant.tenantName" maxlength="80" :show-word-limit="true" style="width: 300px;" clearable :placeholder="$t('login.companyHolder')"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="updateTenantProfile">{{$t('commons.save')}}</el-button>
        </el-form-item>
    </el-form>
</template>

<script>
let tenant = require("@/api/iori/tenant.js")
export default {
    data() {
        return {
            tenant: {
                tenantName: ''
            },
            productKey: '',
            tenantFormRule: {
                tenantName: [{
                    required: true,
                    trigger: ['blur', 'change'],
                    message: this.$t('validate.required')
                }],
            }
        }
    },
    created() {
        let tenantList = this.$store.getters.tenantList
        this.productKey = this.$store.getters.currentProductKey
        let currentTenant = this.$store.getters.currentTenant
        if(currentTenant && tenantList) {
            for(let i =0; i < tenantList.length; i++) {
                if(tenantList[i].tenantId == currentTenant) {
                    this.tenant.tenantName = tenantList[i].tenantName
                    return
                }
            }
        }
    },
    methods: {
        updateTenantProfile() {
            this.$refs.tenantForm.validate((v)=>{
                if(v) {
                    tenant.updateTenantName(this.tenant).then((r)=>{
                        if(r > 0) {
                            this.$message({type: 'success', message: this.$t('message.updateSuccess')});
                        } else {
                            this.$message({type: 'error', message: this.$t('message.updateFail')});
                        }
                    })
                }
            })

        }
    }
}
</script>
